import React from 'react';
import { useTranslation } from 'react-i18next';

import { NotificationSeverity, NotificationType } from 'clipsal-cortex-types/src/api/api-notifications';

import { NOTIFICATION_SEVERITY_TYPE_TO_COLOR_MAP, NOTIFICATION_TYPE_TO_CONFIG } from './constants';

/**
 * Accepts a notification type & severity and returns the respective UI config.
 * The default test config is returned if there is no match.
 *
 * @param type - The notification type
 * @param severity - The notification severity (default: INFO)
 * @returns The UI config object
 */
export function useGetNotificationConfigForType(type: NotificationType, severity = 'INFO' as NotificationSeverity) {
  const { t } = useTranslation();

  const {
    icon: NotificationIcon,
    testId,
    width,
    height,
    child,
  } = NOTIFICATION_TYPE_TO_CONFIG[type] || NOTIFICATION_TYPE_TO_CONFIG.TEST;

  return {
    icon: (
      <NotificationIcon
        width={width ?? 10}
        height={height ?? 10}
        data-testid={testId}
        color={NOTIFICATION_SEVERITY_TYPE_TO_COLOR_MAP[severity] || NOTIFICATION_SEVERITY_TYPE_TO_COLOR_MAP.INFO}
      />
    ),
    child,
    title: t(`Notifications.types.${type}.title`),
  };
}
